import React from "react";
// import "../Styles/badgeAnimation.css";

function VerifyBadge(props) {
  return (
    <div className="o-circle c-container__circle o-circle__sign--success">
      <div className="o-circle__sign" />
    </div>
  );
}

export default VerifyBadge;
